import React, {ReactElement, useEffect} from 'react';
import {Formik, Form, Field} from 'formik';
import * as Yup from 'yup';
import ErrorToast from '../../../components/notifications/ErrorToast';
import cogoToast from 'cogo-toast';
import {LOCATION, STORE_LOCATION} from '../../../routes/route-constants';
import {useHistory} from 'react-router-dom';
import AppHeader from '../../../components/appbar/AppBar';
import {setPageName} from '../../../lib/tagmanager';
import {pageName} from '../../../lib/constants';
import {useAppDispatch, useAppSelector} from '../../../redux/hooks';
import useGeoLocation from '../../../components/common/useGeoLocation';

import {
  employeeResetPassword,
  employeeResetPasswordData,
  loading,
  error,
} from '../../../redux/employeeResetPasswordSlice';
import {employeeIdData} from '../../../redux/employeeIdSlice';
import {distancePoints} from '../../../lib/commonFunction';
import {getStoreEmployeeInfo} from '../../../core/localstorage-data';
import SuccessToast from '../../../components/notifications/SuccessToast';

const employeeResetpassword = (): ReactElement => {
  const navigate = useHistory();
  const dispatch = useAppDispatch();
  const location = useGeoLocation();

  const employeeId = useAppSelector(employeeIdData);
  const employeeInfo = getStoreEmployeeInfo;
  const employeeNewPasswordData = useAppSelector(employeeResetPasswordData);
  const employeeDataHasLoaded = useAppSelector(loading);
  const errorInEmployeeData = useAppSelector(error);
  useEffect(() => {
    if (employeeId === '' || employeeInfo === null) {
      console.log(employeeInfo, employeeId);
      localStorage.clear();
      window.location.href = 'employeesignin';
    }
    setPageName(pageName.resetpassword);
  }, []);
  useEffect(() => {
    if (
      employeeNewPasswordData.statusMessage != '' &&
      employeeDataHasLoaded === false
    ) {
      if (employeeNewPasswordData.statusCode == '200') {
        cogoToast.success(
          <SuccessToast
            title="Success!"
            description={employeeNewPasswordData.statusMessage}
          />,
          {
            hideAfter: 2,
            renderIcon: () => {
              return null;
            },
          },
        );
        const storeLat = 28.7254557;
        const storeLong = 77.2060128;
        const userLat = 28.7234;
        const userLong = 77.206;
        // const storeLat = storeInformationData.latitude;
        // const storeLong = storeInformationData.longitude;
        // const userLat = location.coordinates.lat;
        // const userLong = location.coordinates.lng;
        const distance = distancePoints(
          userLat,
          userLong,
          storeLat,
          storeLong,
          //getStoreLatitude(),
          //getStoreLongitude(),
        );
        if (distance <= 300) {
          navigate.push(STORE_LOCATION);
        } else {
          navigate.push(LOCATION);
        }
      } else {
        cogoToast.error(
          <ErrorToast
            title="Error"
            description={employeeNewPasswordData.statusMessage}
          />,
          {
            hideAfter: 4,
            renderIcon: () => {
              return null;
            },
          },
        );
      }
    }
    if (errorInEmployeeData != '' && employeeDataHasLoaded === false) {
      cogoToast.error(
        <ErrorToast title="Error" description="Internal Server Error" />,
        {
          hideAfter: 5,
          renderIcon: () => {
            return null;
          },
        },
      );
    }
  }, [employeeNewPasswordData, employeeDataHasLoaded, errorInEmployeeData]);

  const initialValues = {
    oldpassword: '',
    password: '',
    confirmpassword: '',
  };

  const validationSchema = Yup.object({
    oldpassword: Yup.string()
      .max(40, 'Max length execeeding')
      .required('Please enter old password'),

    password: Yup.string()
      .max(40, 'Max length execeeding')
      .matches(
        /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)[A-Za-z\d@$!%*#?&^_-]{9,}$/,
        'Please enter Min 9 characters, 1 uppercase, 1 lower case, 1 numeric ',
      )
      .required('*Please enter password'),
    confirmpassword: Yup.string()
      .max(40, 'Max length execeeding')
      .required('*Please enter confirm password'),
  });
  const onSubmit = (
    values: any,
    submitProps: {
      setSubmitting: (arg0: boolean) => void;
      resetForm: () => void;
    },
  ) => {
    submitProps.setSubmitting(false);
    if (location.error.message != '') {
      cogoToast.error(
        <ErrorToast
          title="Error"
          description="Please allow location to continue"
        />,
        {
          hideAfter: 5,
          renderIcon: () => {
            return null;
          },
        },
      );
      submitProps.resetForm();
      return;
    }

    if (values.password === values.confirmpassword) {
      const parameter = {
        userId: employeeId,
        oldPassword: values.oldpassword,
        newPassword: values.password,
        confirmPassword: values.confirmpassword,
      };

      dispatch(employeeResetPassword(parameter));
    } else {
      cogoToast.error(
        <ErrorToast
          title="Error"
          description="Password and confirm password does not match"
        />,
        {
          hideAfter: 5,
          renderIcon: () => {
            return null;
          },
        },
      );
    }

    submitProps.resetForm();
  };

  return (
    <div className="h-full">
      <AppHeader bgColor="transparent" />
      <div className="py-4 px-8 top-spacing-ipad">
        <div className="grid place-items-center overflow-y-auto">
          <span className="font-roboto text-big text-center font-bold">
            Reset Password
          </span>
        </div>
        <div className="mt-2">
          <p className="text-sm mt-2 text-black_zero text-center text-opacity-50 font-roboto">
            Set a new password
          </p>
        </div>
        <div className="mt-1">
          <Formik
            className="flex justify-items-stretch mx-auto max-w-screen-md relative flex-grow mt-6"
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={onSubmit}
            enableReinitialize>
            {formik => {
              return (
                <Form>
                  <div className="pt-6">
                    <div
                      className={`grid h-50 border-opacity-50 py-1 rounded-radius10  bg-blue_four hover:bg-white   ${
                        formik.errors.oldpassword && formik.touched.oldpassword
                          ? // && formik.values.firstname.length > 0
                            'input_error'
                          : 'input_valid'
                      }`}>
                      <span className="text-black_zero text-xs text-left font-roboto ml-2.5 mt-1.5 font-bold">
                        Old password
                        <span className="text-dark_red">*</span>
                      </span>
                      <Field
                        type="password"
                        name="oldpassword"
                        onPaste={(e: {preventDefault: () => void}) => {
                          e.preventDefault();
                          return false;
                        }}
                        onCopy={(e: {preventDefault: () => void}) => {
                          e.preventDefault();
                          return false;
                        }}
                        placeholder="Enter old password"
                        className="focus:outline-none w-10/12 font-roboto text-sm ml-2.5 -mt-2 bg-transparent"
                      />
                    </div>
                    {formik.errors.oldpassword && formik.touched.oldpassword ? (
                      <div className="text-red-600 text-xs font-roboto ml-2.5 mt-1">
                        {formik.errors.oldpassword}
                      </div>
                    ) : null}
                  </div>

                  <div className="pt-6">
                    <div
                      className={`grid h-50 border-opacity-50 py-1 rounded-radius10  bg-blue_four hover:bg-white   ${
                        formik.errors.password && formik.touched.password
                          ? // && formik.values.firstname.length > 0
                            'input_error'
                          : 'input_valid'
                      }`}>
                      <span className="text-black_zero text-xs text-left font-roboto ml-2.5 mt-1.5 font-bold">
                        New password
                        <span className="text-dark_red">*</span>
                      </span>
                      <Field
                        type="password"
                        name="password"
                        onPaste={(e: {preventDefault: () => void}) => {
                          e.preventDefault();
                          return false;
                        }}
                        onCopy={(e: {preventDefault: () => void}) => {
                          e.preventDefault();
                          return false;
                        }}
                        placeholder="Enter password"
                        className="focus:outline-none w-10/12 font-roboto text-sm ml-2.5 -mt-2 bg-transparent"
                      />
                    </div>
                    {formik.errors.password && formik.touched.password ? (
                      <div className="text-red-600 text-xs font-roboto ml-2.5 mt-1">
                        {formik.errors.password}
                      </div>
                    ) : null}
                  </div>
                  <div className="mt-6">
                    <div
                      className={`grid h-50 border-opacity-50 py-1 rounded-radius10  bg-blue_four hover:bg-white   ${
                        formik.errors.confirmpassword &&
                        formik.touched.confirmpassword
                          ? // && formik.values.firstname.length > 0
                            'input_error'
                          : 'input_valid'
                      }`}>
                      <span className="text-black_zero text-xs text-left font-roboto ml-2.5 mt-1.5 font-bold">
                        Confirm Password
                        <span className="text-dark_red">*</span>
                      </span>
                      <Field
                        type="password"
                        name="confirmpassword"
                        onPaste={(e: {preventDefault: () => void}) => {
                          e.preventDefault();
                          return false;
                        }}
                        onCopy={(e: {preventDefault: () => void}) => {
                          e.preventDefault();
                          return false;
                        }}
                        placeholder="Re-enter password"
                        className="focus:outline-none w-10/12 font-roboto text-sm ml-2.5 -mt-2 bg-transparent"
                      />
                    </div>
                    {formik.errors.confirmpassword &&
                    formik.touched.confirmpassword ? (
                      <div className="text-red-600 text-xs font-roboto ml-2.5 mt-1">
                        {formik.errors.confirmpassword}
                      </div>
                    ) : null}
                  </div>
                  <div style={{marginTop: '24px'}}>
                    <button
                      className={`cursor-none-allowed text-white h-50 rounded-radius10  grid place-items-center focus:outline-none w-full text-center primary normal`}
                      type="submit"
                      disabled={!(formik.dirty && formik.isValid)}>
                      <p className="font-bold font-roboto">Continue</p>
                    </button>
                  </div>
                </Form>
              );
            }}
          </Formik>
        </div>
      </div>
    </div>
  );
};

export default employeeResetpassword;
